import React from 'react';
// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => (
  <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.8 14.7L13.3 12.2C14.4 11 15 9.3 15 7.5C15 3.4 11.6 0 7.5 0C3.4 0 0 3.4 0 7.5C0 11.6 3.4 15 7.5 15C9.3 15 10.9 14.4 12.2 13.3L14.7 15.8C14.8 15.9 15 16 15.2 16C15.4 16 15.6 15.9 15.7 15.8C16.1 15.5 16.1 15 15.8 14.7ZM7.5 13.5C4.2 13.5 1.5 10.8 1.5 7.5C1.5 4.2 4.2 1.5 7.5 1.5C10.8 1.5 13.5 4.2 13.5 7.5C13.5 10.8 10.8 13.5 7.5 13.5Z" fill="currentcolor" />
  </svg>
);
